import logger from "../../helpers/logger";

let sCD;

export const setConfirmDialogHandler = (fn) => {
  sCD = fn;
};

export const confirm = ({ title, content, disableBackdropClose = true }) => {
  return new Promise((resolve) => {
    if (sCD) {
      sCD({ title, content, resolve, disableBackdropClose });
    } else {
      logger.warn("ConfirmDialogManager is not mounted yet.");
      resolve(false);
    }
  });
};
